import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery, getUrl} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {
    PrintCategoryCreateDTO,
    PrintCategoryDTO,
    PrintCategoryEditDTO
} from "../../types/printCategory/PrintCategoryDTO";
import {DeleteParams} from "../../types/utils/Constants";

export const printCategoryApi = createApi({
    reducerPath: "printCategory",
    baseQuery: apiQuery,
    tagTypes: ["printCategories"],
    endpoints: builder => ({
        getPrintCategories: builder.query<Response<PrintCategoryDTO[]>, Partial<number | undefined>>({
            query: (accountId) => getUrl('/print-categories', [{name: "account_id", value: accountId}]),
            providesTags: ['printCategories']
        }),
        createPrintCategory: builder.mutation <void, Partial<PrintCategoryCreateDTO>>({
            query: (body) => ({
                url: "/print-categories",
                method: "POST",
                body
            }),
            invalidatesTags: ["printCategories"]
        }),
        editPrintCategory: builder.mutation <void, Partial<PrintCategoryEditDTO>>({
            query: (body) => ({
                url: `/print-categories/${body.id}`,
                method: "PATCH",
                body
            }),
            invalidatesTags: ["printCategories"]
        }),
        deletePrintCategory: builder.mutation <void, Partial<DeleteParams>>({
            query: (params) => ({
                url: getUrl(`/print-categories/${params.id}`, [{name: "account_id", value: params.accountId}]),
                method: "DELETE"
            }),
            invalidatesTags: ["printCategories"]
        }),
    })
})

export const {
    useGetPrintCategoriesQuery,
    useCreatePrintCategoryMutation,
    useEditPrintCategoryMutation,
    useDeletePrintCategoryMutation
} = printCategoryApi
